import { twMerge } from "tailwind-merge";
import { MicOff } from "lucide-react";
import { useBreakpoint } from "@core/hooks/useBreakpoint";

export type Props = {
  className?: string;
  muted: boolean;
  isWithContentShare?: boolean;
};

export function VideoUITileAudioIcon({
  muted,
  className,
  isWithContentShare,
}: Props) {
  const isMd = useBreakpoint("md");

  if (!muted) return null;

  return (
    <div
      className={twMerge(
        "absolute bottom-1 right-1 px-2 py-2 rounded-md bg-brand-900/90 backdrop-blur",
        className
      )}
    >
      <MicOff
        size={isWithContentShare ? 12 : 16}
        className={twMerge(
          "text-brand-400 transition-all duration-100",
          className
        )}
      />
    </div>
  );
}

export default VideoUITileAudioIcon;
